export default __webpack_public_path__ + "static/media/ic_bsc_96.79853d5a.svg";